<div class="box-border-bg box-shadow box-radius custom-popup">
    <div class="filter-name-panel-container">
        <div class="name-pop-up">
            <div>
                <span class="title">Save Filter Selections</span>
            </div>

            <div class="name-query-title-container" >
                <div class="name-query-title-container-inner">
                    Enter a name for this set of saved filters:
                </div>
                <div class="filter-name-input-div" >
                    <input
                            [(ngModel)]="inputModel"
                            (ngModelChange)="textChange()"
                            (keydown)="keyEvent($event)"
                            type="text"
                            id="savedFilterName"
                            maxlength="40"
                            style="width: 40vw;"
                            autofocus
                    />
                </div>
            </div>
        </div>
        <div class="save-cancel-container">
            <div class="link-cancel-container" >
                <a class="link-blue"(click)="clickCloseLink()">
                    Cancel
                </a>
            </div>
            <div class="save-btn" >
                <button
                class="button-blue"
                id="saved-filter-btn"
                (click)="clickSaveButton()">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>
